import { ChangelogItem } from "src/features/changelog/changes/types";

export function getRelevantChanges(
	changes: ChangelogItem[],
	modules: string[]
): ChangelogItem[] {
	return changes.filter(
		change =>
			change.modules.length === 0 ||
			change.modules.some(module => modules.includes(module))
	);
}
